var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_54978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0249 50.4097L12.0934 33.056C10.6731 32.2845 8.99581 32.3164 7.60594 33.1426C6.21607 33.9686 5.38672 35.4271 5.38672 37.044V77.3006C5.3876 78.1023 5.60039 78.8895 6.00353 79.5825C6.40667 80.2754 6.98584 80.8495 7.68233 81.2465L39.6144 99.3998C40.3183 99.7999 41.0881 99.9998 41.858 99.9998C42.6427 99.9998 43.4271 99.7921 44.1404 99.377C45.5531 98.555 46.3965 97.0884 46.3965 95.4537V54.3978C46.3965 52.7331 45.488 51.2049 44.0249 50.4097ZM88.8206 22.5847C88.8212 21.7538 88.5929 20.9387 88.1607 20.2289C87.7285 19.5192 87.1092 18.9422 86.3707 18.5613L51.5504 0.509144C50.9007 0.172318 50.1791 -0.00243459 49.4472 -0.000223415C48.7154 0.00198776 47.9949 0.181097 47.3472 0.521843L13.039 18.574C12.3073 18.9578 11.6945 19.5345 11.2671 20.2416C10.8396 20.9487 10.6137 21.7592 10.6139 22.5855C10.6117 23.4116 10.8357 24.2226 11.2614 24.9306C11.6871 25.6386 12.2984 26.2167 13.0291 26.6021L47.3374 44.767C47.9875 45.1112 48.7116 45.2922 49.4472 45.2944C50.1828 45.2966 50.9079 45.1199 51.56 44.7795L86.381 26.615C87.1186 26.2321 87.7365 25.6535 88.1668 24.9425C88.5972 24.2315 88.8234 23.4158 88.8206 22.5847ZM92.3955 33.1426C91.0064 32.3164 89.3284 32.2837 87.9086 33.0558L55.9762 50.4097C55.2585 50.7994 54.6594 51.3756 54.2421 52.0775C53.8247 52.7794 53.6046 53.581 53.6049 54.3976V95.4535C53.6049 97.0882 54.4484 98.5548 55.8611 99.3768C56.5744 99.7919 57.3586 99.9994 58.1434 99.9994C58.9132 99.9994 59.6833 99.7996 60.3871 99.3996L92.3193 81.2463C93.0158 80.8493 93.5949 80.2752 93.998 79.5823C94.4011 78.8893 94.6139 78.1021 94.6147 77.3004V37.044C94.6147 35.4271 93.7854 33.9686 92.3955 33.1426Z",
    fill: "url(#paint0_linear_4_54978)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_54978",
    x1: 5.38672,
    y1: 0.985332,
    x2: 123.438,
    y2: 104.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_54978"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.7f737fd6a79fa78bf4ea885c05970ca6.svg";
export { ForwardRef as ReactComponent };